export default "__VITE_ASSET__c0f4463e__"